export default {
  ADD_DISCLOSURE_INFORMATION (state, docs) {
    state.disclosureInformation = docs
  },
  ADD_NEW_DISCLOSURE_INFORMATION (state, doc) {
    state.disclosureInformation.push(doc)
  },
  DELETE_DISCLOSURE_INFORMATION (state, id) {
    state.disclosureInformation = state.disclosureInformation.filter(d => d.id !== id)
  },
  UPDATE_DISCLOSURE_INFORMATION (state, data) {
    Object.assign(state.disclosureInformation.find(d => d.id === data.id), data)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/disclosureInformation.js